import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../utils/ConstantLinks";
import { useAuthContext } from "../../context/auth.context";
import { usePrivateContext } from "../../context/private.context";
import { LogOutIcon, PasswordLockIcon } from "../../assets/svg";

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const {
    auth: { authData: {firstName, lastName, email} },
  } = usePrivateContext();
  const { onLogout } = useAuthContext();
  return (
    <div className="flex flex-col gap-0.5 px-2.5 py-2.5">
      <div className="flex items-center px-2 pb-1.5 border-b">
          <div className="flex flex-col gap-1">
            <span className="!text-secondary-dark text-capitalize">
              {`${firstName} ${lastName}`}
            </span>
            <span className="text-secondary-light text-xs">
              {email}
            </span>
          </div>
        </div>
      <div
        className="flex items-center px-1 py-1 hover:bg-[#f3f3f3] rounded-md cursor-pointer"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <PasswordLockIcon height={18} width={20} />
        <span className="!text-secondary-dark mx-2 text-nowrap">
          Change Password
        </span>
      </div>
      <div
        className="flex items-center px-1.5 py-1 hover:bg-[#f3f3f3] rounded-md cursor-pointer"
        onClick={(event) => {
          event.stopPropagation();
          onLogout();
          navigate(LOGIN);
        }}
      >
        <LogOutIcon height={16} width={16} />
        <span className="!text-secondary-dark mx-2.5">
          Log Out
        </span>
      </div>
    </div>
  );
};

export default ProfileDropdown;
